import { useState } from "react";
import Search from "../../components/UserDashboard/Search";
import SideBar from "../../components/UserDashboard/SideBar";
import "../../styles/shared/Suggestion.scss";
import { submitSuggestion } from "../../apis/General/users";
import { toast } from "react-toastify";
import { getDatabase, push, ref } from "firebase/database";
import { useSelector } from "react-redux";


const Suggestion = () => {
  const auth = useSelector((state) => state.auth);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const db = getDatabase();


  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true);
    const response = await submitSuggestion(title, message);
    if (response?.data?.statusCode === 200) {
      toast.success("Thank you for your suggestion");
      push(ref(db, "notifications"), {
        type: "Suggestion Received",
        read: false,
        user: auth?.userInfo?.id,
        timestamp: Date.now(),
      });
      setTitle("");
      setMessage("");
    } else {
      toast.error(response?.data?.message);
    }
    setLoading(false);
  };

  return (
    <div className="suggestion">
      <div className="sidebar_container">
        <SideBar />
      </div>

      <div className="suggestion_main">
        <Search />

        <form className="suggestion_form" onSubmit={handleSubmit}>
          <label htmlFor="title">Title</label>
          <input
            className="suggestion_input"
            name="title"
            id="title"
            type="text"
            placeholder="Title of your suggestion"
            required
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <label htmlFor="title">Message</label>
          <textarea
            name="message"
            id="message"
            placeholder="Give as many details as possible"
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
          <button type="submit" disabled={loading}>{loading ? 'Loading...' : 'Send'}</button>
        </form>
      </div>
    </div>
  );
};

export default Suggestion;
